export enum Browsers {
  Safari = 'Safari',
  Chrome = 'Chrome',
  Firefox = 'Firefox',
}
